<template>
  <a-modal
    v-if="record"
    title="请确认本次面试结果"
    :destroyOnClose="true"
    v-model="visible"
    :width="1000"
    :footer="null"
  >
    <h3>
      <b>面试信息：</b>
    </h3>
    <a-row
      class="row"
      type="flex"
      justify="space-between"
      :gutter="20"
      style="padding:10px 0 0 25px"
    >
      <a-col span="12">
        <p>
          <b>面试类型：</b>
          {{ interview.type_text }}
        </p>
      </a-col>
      <a-col span="12">
        <p>
          <b>候选人：</b>
          {{ record.resume_name }}
        </p>
      </a-col>
      <a-col span="12">
        <p>
          <b>面试职位：</b>
          {{ record.job_name }}
        </p>
      </a-col>
      <a-col span="12">
        <p>
          <b>面试时间：</b>
          {{ interview.time }}
        </p>
      </a-col>
      <a-col span="12">
        <p>
          <b>面试地点：</b>
          {{ interview.address }}
        </p>
      </a-col>
      <a-col span="12">
        <p>
          <b>附言：</b>
          {{ interview.remark }}
        </p>
      </a-col>
    </a-row>
    <soft-comment ref="comment"></soft-comment>
    <a-divider></a-divider>
    <a-row type="flex" :gutter="10" justify="end">
      <a-col>
        <a-button type="primary" @click="handleOk" :loading="sureLoading"
          >面试通过</a-button
        >
      </a-col>
      <a-col>
        <a-button @click="handleCancel" :loading="cancelLoading"
          >面试未过</a-button
        >
      </a-col>
    </a-row>
  </a-modal>
</template>

<script>
import SoftComment from "@/components/soft-comment";
import Api from "@/api";
export default {
  name: "CheckInterviewModal",
  data() {
    return {
      visible: false,
      sureLoading: false,
      cancelLoading: false,
      record: undefined,
      interview: undefined
    };
  },
  components: { SoftComment },
  computed: {},
  created() {},
  methods: {
    show(record) {
      this.record = { ...record };
      this.interview = record.interviews[0];
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    //通过面试
    async handleOk() {
      this.sureLoading = true;
      try {
        await this.softSkill();
        await Api.order.interviewConfirm({ post_id: this.record.id });
        this.close();
        this.$emit("ok", this.record);
      } catch (e) {}
      this.sureLoading = false;
    },
    //通过未面试
    async handleCancel() {
      this.cancelLoading = true;
      try {
        await this.softSkill();
        this.close();
        this.$emit("cancel", this.record);
      } catch (e) {}
      this.cancelLoading = false;
    },
    softSkill() {
      return new Promise(async (resolve, reject) => {
        let tags = this.$refs.comment.getCommentFormData();
        if (tags) {
          try {
            await Api.resume.createSoftSkill({
              resume_id: this.record.resume_id,
              tags
            });
            resolve();
          } catch (e) {
            reject();
          }
        } else {
          reject();
        }
      });
    }
  }
};
</script>

<style scoped lang="scss"></style>
